@if (!referLink) {
  <div class="referrals-wrapper" style="background-image: url('/assets/images/referrals-bg.webp');">
    <div class="content-width text-center">
      <div class="referrals-content">
        <h1>Refer friends and get rewarded!</h1>
        <div class="referrals-benefits">
          <div class="benefit d-flex align-items-center">
            <div class="benefit-image">
              <img width="105" src="/assets/images/love-icon.svg" alt="">
            </div>
            <div class="benefit-text">
              <p>If you love Family Central, share it with others and they’ll get a free month.</p>
            </div>
          </div>
          <div class="benefit d-flex align-items-center">
            <div class="benefit-image">
              <img width="80" src="/assets/images/free-tiral-icon.svg" alt="">
            </div>
            <div class="benefit-text">
              <p>There’s no risk for them. The first month’s trial is free and no credit card is required.
              </p>
            </div>
          </div>
          <div class="benefit d-flex align-items-center">
            <div class="benefit-image">
              <img width="100" src="/assets/images/infinite-icon.svg" alt="">
            </div>
            <div class="benefit-text">
              <p>You can refer an infinite number of friends. Each one who signs up for a paid
              subscription earns you another feee month!</p>
            </div>
          </div>
        </div>
        @if (isSMBLDomain) {
          <div class="input-group">
            <label style="padding-right: 50px;padding-top: 10px;">Expiry Date</label>
            <input style="border-radius: 10px;" class="form-control mb-0" [(ngModel)]="endDate" type="date">
          </div>
        }
        <div class="form-check read-agree">
          <input type="checkbox" id="readAgree" class="form-check-input" [(ngModel)]="isAccepted">
          <label class="form-check-label" for="readAgree">I have read and agree to the <a
          routerLink="/termsconditions">Terms & Conditions</a></label>
        </div>
        <div class="referrals-btn">
          <button type="button" class="primary_btn" disableDuringAjax (click)="getReferralLink()">Get Your
            Code and
          Share!</button>
        </div>
      </div>
    </div>
  </div>
}
@if (referLink) {
  <div class="referrals-wrapper send-email-friend"
    style="background-image: url('../assets/images/referrals-step2-bg.webp');">
    <div class="content-width text-center">
      <div class="referrals-step1">
        <div class="refer-friends mb-5">
          <h1 class="heading2">Copy this link and share!</h1>
          <div class="input-group copy_link">
            <input type="text" class="form-control" [ngModel]="referLink"
              aria-label="Copy this link and share!" readonly>
              <button class="copy_link_btn" type="button" (click)="copylink()">
                <img src="../assets/images/copy-icon.svg" alt="">
                <span>Copy link</span>
              </button>
            </div>
            <p class="sofialight friend-signs mb-0">If a friend signs up, you both get 14 days free!
            </p>
          </div>
          <div class="refer-friends mb-3">
            <h2 class="heading2 mb-2">Send Emails to Friends</h2>
            <p class="sofialight refer-friends mb-0">You can refer any number of friends. Just enter
              their email
            addresses, separated by commas, in the field below:</p>
          </div>
          <div class="input-group">
            <input [(ngModel)]="email" type="email" class="form-control"
              placeholder="Friendone@email.com, friendtwo@email.com" required #emailTouched="ngModel">
            </div>
            <div class="family-app-offer text-start">
              <p>Hi! I use Family Central, an app that organizes families’ day-to-day chaos while
                helping prepare for
                the passing of loved ones. It gives me the peace of mind in knowing details for
                today and tomorrow
                are organized – documents are within reach at a moment’s notice and I can know where
                each family
                member is at a glance with GPS tracking. It is easy to use & they have real experts
                to help. If you
              use my link, and subscribe, you and I can both get a free month. It's a win-win!</p>
              <p>Here’s the link to follow:</p>
              <p style="word-wrap: break-word">{{referLink}}</p>
            </div>
            <div class="form-check read-agree">
              <input type="checkbox" class="form-check-input" id="reminder" name="reminder" value="reminder">
              <label class="form-check-label" for="reminder">Send a reminder in 3 days</label>
            </div>
            <div class="referrals-cta d-flex justify-content-center">
              <button type="button" class="btn btn-default dark-blue-btn"  (click)="sendEmail(emailTouched)"
                disableDuringAjax><img src="../assets/images/email-white.svg" alt=""> Send
              emails</button>
            </div>
          </div>
        </div>
      </div>
    }